import React, { useState, useEffect } from "react";
import styles from "./ImageCarouselCard.module.scss";
import useWindowResize from '../../hooks/useWindowResize';

const ImageCarouselCard = ({ image, name, bigSlides }) => {
  const [mouseEnter, setMouseEnter] = useState(false);
  const isBelowMedium = useWindowResize(768)

  const handleMouse = () => {
    if(!isBelowMedium){
      setMouseEnter(!mouseEnter);
    }
  };

  useEffect(() => {
    if(isBelowMedium){
      setMouseEnter(false);
    }
  },[isBelowMedium])

  return (
    <>
      <div
        className={bigSlides? styles.eventCard : null}
      >
        <img src={image?.src} alt={image?.alt}></img>
      </div>
      <div style={{height: mouseEnter ? 0 : "40px"}}>
        <div
          className={styles.name}
          style={{ display: (mouseEnter || isBelowMedium) && !bigSlides ? "block" : "none" }}
        >
          {name}
        </div>
      </div>
    </>
  );
};

export default ImageCarouselCard;
